module.exports = __webpack_public_path__ + "img/footer logo.f7dd88e5.svg";